import { useState } from "react";
import { formatUnixToReadable } from "../../utils/time";

const EVENT_COLORS = {
  fire: "#e74c3c",
  restriction_zone: "#f1c40f",
  number_plate: "#ae00ffff",
  person_checkin: "#2ecc71",
  person_checkout: "#3498db",
  unknown: "#95a5a6",
};

const MultiTimelineGraph = ({ timelines = [], startTime, endTime, onEventClick }) => {
  const [tooltip, setTooltip] = useState(null);

  const totalDuration = endTime - startTime;

  const handleMouseEnter = (e, event, cameraId) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({
      x: e.clientX,
      y: rect.top,
      label: event.label || event.type || "Unknown Event",
      timestamp: event.timestamp,
      cameraId,
      data: event.data,
    });
  };

  const handleMouseLeave = () => setTooltip(null);

  return (
    <div className="multi-timeline-container">
      {timelines.map((timeline, idx) => (
        <div key={timeline?.id || idx} className="timeline-block">
          <div className="timeline-track">
            {timeline?.events.map((event, i) => {
              // ✅ Normalize timestamp within range
              const relativePosition = ((event.timestamp - startTime) / totalDuration) * 100;
              const left = `${Math.max(0, Math.min(100, relativePosition))}%`; // Clamp to 0–100%
              // const type = event.type || "unknown";
              const color = timeline?.color || "#bdc3c7";

              // console.log("[INFO] color: ", timeline);

              return (
                <div
                  key={i}
                  className="event-indicator"
                  style={{ left, backgroundColor: color }}
                  onMouseEnter={(e) => handleMouseEnter(e, event, timeline?.id)}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => onEventClick?.(timeline?.id, event.timestamp)}
                />
              );
            })}
          </div>
        </div>
      ))}

      {tooltip && (
        <div className="custom-tooltip" style={{ left: tooltip.x, top: tooltip.y - 45 }}>
          <div>
            <strong>{tooltip.label}</strong>
          </div>
          <div>
            <small>
              {formatUnixToReadable(tooltip.timestamp)} – {tooltip.cameraId}
            </small>
          </div>
          {tooltip.data?.confidence && (
            <div>
              <small>Confidence: {(tooltip.data.confidence * 100).toFixed(1)}%</small>
            </div>
          )}
          {tooltip.data?.time_spent && (
            <div>
              <small>Time spent: {(tooltip.data.time_spent * 100).toFixed(1)}seconds</small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiTimelineGraph;
